import { nonEmptyTrimmedStringFromUnknown } from "./shared.js";
import { clientMessageIdSchema } from "./client-message-id.js";
import * as z$1 from "zod/v4";
//#region src/schemas/protocol/server-error.ts
const serverErrorFrameSchema = z$1.object({
	error: nonEmptyTrimmedStringFromUnknown,
	requestId: nonEmptyTrimmedStringFromUnknown.optional(),
	clientMessageId: clientMessageIdSchema.optional()
});
//#endregion
export { serverErrorFrameSchema };

//# sourceMappingURL=server-error.js.map